import { FetchNewSupportCallProps } from "../models/newSupportCall";
import { IMaintenanceHistoryResponse } from "../models/volksPlanEssential";
import ApiService from "../services/api";

export const editMaintenanceGroup = async (chassi?: string, customMaintenanceGroup?: string): Promise<any> => {
  if (!chassi || !customMaintenanceGroup) return null;

  const apiService = new ApiService();
  const url = `/assets/${chassi}`;
  const body = {
    customMaintenanceGroup
  }

  try {
    await apiService.patch<any>(url, body, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    return true;

  } catch (error) {
    console.error("Erro ao criar nova solicitação:", error);
    return null;
  }
};

export const fetchUpdateHistoryByChassis = async (chassi: string, size: number, page: number): Promise<IMaintenanceHistoryResponse | null> => {
    const apiService = new ApiService();

    const url = `audit-logs/MAINTENANCE_GROUP/${chassi}`;

    try {
      const response = await apiService.get<any>(url);
      
      return response.data;
    } catch (error) {
      console.error(error);
      return null;
    }
}